import { formatDateWithTime } from '@folio/lib';
import type { ReactNode } from 'react';
import { useInboxDate } from './threadHelpers';

export function InboxDate({
  date,
  className,
  children,
}: {
  date: string;
  className?: string;
  children?: ReactNode;
}) {
  const formatInboxDate = useInboxDate();

  return (
    <time className={className} dateTime={date} title={formatDateWithTime(new Date(date))}>
      {formatInboxDate(date)}
      {children}
    </time>
  );
}
